import pulse from "@finn-no/pulse-sdk";

export function trackPageView(): void {
  pulse.trackPageView({
    type: "View",
    object: {
      type: "Page",
      pageType: "landingpage",
    },
    vertical: {
      name: "effect_documentation",
      subVertical: "realestate",
    },
  });
}

export function trackBlinkPreviewVisited(): void {
  pulse.trackPageView({
    object: {
      type: "Page",
      pageType: "tool",
      name: 'blink_preview',
    },
  });
}

export function trackBlinkPreviewRequest(): void {
  pulse.trackEvent({
    type: 'Click',
    intent: 'Search',
    name: 'Blink preview request',
    object: {
      id: 'blink_preview_request',
      type: 'UIElement',
      elementType: 'Button',
    },
    action: {
      type: "Request",
    },
  });
}
